
import { computed } from 'vue';
import { useStore } from 'vuex';

// types
import { Status } from '@/models/todos';

// enums
import { TodosMutationTypes } from '@/models/todos';

export default {
  name: 'Options',
  setup() {
    const store = useStore();

    const status = computed(() => store.state.todos.status);
    const activeTodosCount = computed(() => store.getters.activeTodos.length);
    const doneTodosCount = computed(() => store.getters.doneTodos.length);
    const allTodosCount = computed(() => store.getters.allTodos.length);

    const handleSetStatus = (status: Status) => {
      store.commit(TodosMutationTypes.SET_STATUS, status);
    };

    const handleClearCompleted = () => {
      store.commit(TodosMutationTypes.CLEAR_COMPLETED);
      store.commit(TodosMutationTypes.SET_STATUS, 'all');
    };

    return {
      status,
      allTodosCount,
      activeTodosCount,
      doneTodosCount,
      handleSetStatus,
      handleClearCompleted,
    };
  },
};
